/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Verify_TitleInputs */

const en_pc_dl_verify_title = /** @type {(inputs: Pc_Dl_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify your download`)
};

const zh_pc_dl_verify_title = /** @type {(inputs: Pc_Dl_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`校验下载文件`)
};

/**
* | output |
* | --- |
* | "Verify your download" |
*
* @param {Pc_Dl_Verify_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_verify_title = /** @type {((inputs?: Pc_Dl_Verify_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Verify_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_verify_title(inputs)
	return zh_pc_dl_verify_title(inputs)
});
export { pc_dl_verify_title as "pc.dl.verify_title" }